import environment from "@app/config/environment";
import type { CacheLocation } from "@auth0/auth0-react";

const connection = environment.ATI_AUTH0_CONNECTION;
const mode = environment.MODE;
const cacheLocation: CacheLocation = "test" === mode ? "localstorage" : "memory";

export const auth0Config = {
  domain: environment.ATI_AUTH0_DOMAIN,
  clientId: environment.ATI_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: environment.ATI_AUTH0_AUDIENCE,
    redirect_uri: `${window.location.origin}/callback`,
    ...(connection ? { connection } : {})
  },
  useRefreshTokens: true,
  cacheLocation
};
